import { Box, Button, Typography } from '@mui/material';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import { t } from 'i18next';
import {
  faChevronDown,
  faChevronUp,
  faPlus
} from 'vendors/@fortawesome/pro-light-svg-icons';
import NoteForm from './NoteForm';

const NotesBar = ({
  requestId,
  showNotes,
  setShowNotes,
  showNoteForm,
  setShowNoteForm,
  notes
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1} width={1}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1.75}
      >
        <Box display="flex" gap={2}>
          <Button
            onClick={() => {
              setShowNotes(!showNotes);
              showNotes && setShowNoteForm(false);
            }}
            color="dark"
            size="small"
            variant="text"
            sx={{ display: 'flex', gap: 1, textTransform: 'none' }}
          >
            <Typography variant="h4" component="h4" sx={{ fontSize: '16px' }}>
              {t('notes')} ({notes?.length})
            </Typography>
            {showNotes ? (
              <>
                <FontAwesomeSvgIcon
                  icon={faChevronUp}
                  fontSize="inherit"
                  color="inherit"
                />
              </>
            ) : (
              <>
                <FontAwesomeSvgIcon
                  icon={faChevronDown}
                  fontSize="inherit"
                  color="inherit"
                />
              </>
            )}
          </Button>
        </Box>
        <Button
          onClick={() => {
            setShowNoteForm(!showNoteForm);
            !showNotes && setShowNotes(true);
          }}
          color="primary"
          size="small"
          variant="outlined"
          sx={{ display: 'flex', width: 'max-content', gap: 1 }}
        >
          {showNoteForm ? (
            <>{t('cancel')}</>
          ) : (
            <>
              <FontAwesomeSvgIcon
                icon={faPlus}
                fontSize="inherit"
                color="primary"
              />
              {t('addNote')}
            </>
          )}
        </Button>
      </Box>
      {showNoteForm && (
        <NoteForm requestId={requestId} setShowNoteForm={setShowNoteForm} />
      )}
    </Box>
  );
};

export default NotesBar;
